import './styles.sass';

import { map, uniq } from 'lodash-es';

import React, { useEffect, useRef } from 'react';

import Transition from 'components/Explorer/Transition';
import PageTitle from 'components/Explorer/PageTitle';
import Pagination from 'components/Explorer/Pagination';
import Spinner from 'components/Explorer/Spinner';
import useExplorerData, { Loading } from 'hooks/useExplorerData';

import Post from './Post';
import Summary from './Summary';
import FilterPanel from './FilterPanel';
import useQueryParams from 'hooks/useQueryParams';

const trackPageChange = (page) => {
  Analytics.trackEvent('mentions-paginate', { page });
};

const Mentions = () => {
  const params = useQueryParams();
  const rootRef = useRef(null);

  const { data, loading } = useExplorerData('mentions', params, { reloadOn: ['filters', 'page'] });

  useEffect(() => {
    if (loading === Loading.SUCCESS || loading === Loading.ERROR || loading === Loading.EMPTY_RESPONSE) {
      const wrapper = rootRef.current?.closest('.Explorer-ContentPanel');
      if (wrapper) wrapper.scrollTop = 0;
    }
  }, [loading]);

  const mentions = data?.data ?? [];
  const lastPage = data?.lastPage ?? null;

  return (
    <div ref={rootRef} className="Explorer-Mentions">
      <PageTitle metaTitle={I18n.t('Explorer.TabBar.mentions')} />
      <FilterPanel />
      <a
        href={I18n.t('Explorer.help.mentions.uri')}
        target="_blank"
        rel="noreferrer"
        title={I18n.t('Explorer.help.mentions.content')}
        className="help"
      >
        {I18n.t('Explorer.help.label_tab')}
      </a>
      <Summary />
      <Transition classNames="Content" timeout={750}>
        <>
          {(loading === Loading.IN_PROGRESS || loading === Loading.NOT_STARTED) && <Spinner key="spinner" />}
          {loading === Loading.ERROR && (
            <div className="Explorer-Mentions-Container">{I18n.t('Explorer.loading_error')}</div>
          )}
          {loading === Loading.SUCCESS && mentions.length !== 0 && (
            <div className="Explorer-Mentions-Container">
              <Pagination lastPage={lastPage} onChangePage={trackPageChange} />
              <div className="mention-timeline">
                {mentions.map(([date, posts]) => {
                  const uniqPosts = uniq(posts);
                  return (
                    <div className="mention-date-boundary" key={`mentions-${date}`}>
                      {map(uniqPosts, (post, index) => (
                        <Post first={index === 0} post={post} key={post.id} />
                      ))}
                    </div>
                  );
                })}
              </div>
              <Pagination lastPage={lastPage} onChangePage={trackPageChange} />
            </div>
          )}
        </>
      </Transition>
    </div>
  );
};

export default Mentions;
